import React from 'react';

// mind. Logo Component
// Minimalist wordmark with accent dot representing mindfulness/habit completion

const Logo = ({ 
  size = 'md', 
  variant = 'full', // 'full' = mind. | 'icon' = just the m with dot
  isDark = true,
  className = '' 
}) => {
  const sizes = {
    xs: { height: 20, fontSize: 16 },
    sm: { height: 28, fontSize: 22 },
    md: { height: 36, fontSize: 28 },
    lg: { height: 48, fontSize: 38 },
    xl: { height: 64, fontSize: 50 },
    '2xl': { height: 96, fontSize: 76 }
  };

  const { height, fontSize } = sizes[size] || sizes.md;
  const textColor = isDark ? '#e8e7e1' : '#141412';
  const accentColor = textColor;

  if (variant === 'icon') {
    // Icon version - stylized "m" with accent dot
    const iconSize = height;
    return (
      <svg 
        width={iconSize} 
        height={iconSize} 
        viewBox="0 0 64 64" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-label="mind. logo"
      >
        {/* Background circle (optional, for app icon use) */}
        <circle cx="32" cy="32" r="30" fill={isDark ? '#0f1110' : '#f7f5ef'} />
        
        {/* Stylized lowercase 'm' */}
        <path
          d="M16 44V28C16 24 18 22 22 22C26 22 28 24 28 28V44M28 28C28 24 30 22 34 22C38 22 40 24 40 28V44"
          stroke={textColor}
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        
        {/* Accent dot */}
        <circle cx="50" cy="44" r="5" fill={accentColor} />
      </svg>
    );
  }

  // Full wordmark version
  const width = height * 3.2;
  
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 160 50" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="mind. logo"
    >
      {/* "mind" text in serif style */}
      <text
        x="0"
        y="38"
        fontFamily="'Noto Serif', Georgia, serif"
        fontSize="40"
        fontWeight="400"
        fill={textColor}
        letterSpacing="-1"
      >
        mind
      </text>
      
      {/* Accent dot */}
      <circle 
        cx="113" 
        cy="38" 
        r="6" 
        fill={accentColor}
      />
    </svg>
  );
};

export default Logo;
